"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferFieldLanguage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const antd_1 = require("antd");
const types_1 = require("@src/types");
const LanguageSelectField_1 = require("@src/components/modules/forms/LanguageSelectField");
const LanguageLevelSelectField_1 = require("@src/components/modules/forms/LanguageLevelSelectField");
const icons_1 = require("@ant-design/icons");
const elements_1 = require("@src/components/elements");
const styled_components_1 = __importDefault(require("styled-components"));
const react_styled_1 = require("styled-breakpoints/react-styled");
const styled_breakpoints_1 = require("styled-breakpoints");
const LanguageSelectFieldWrapper = styled_components_1.default.div `
	width: 15rem;
	max-width: 15rem;
	margin-right: 1rem;
`;
const LanguageLevelSelectFieldWrapper = styled_components_1.default.div `
	width: 4.5rem;
	max-width: 4.5rem;
	margin-right: 1rem;
`;
const RemoveButton = (0, styled_components_1.default)(elements_1.Button) `
	margin-top: 7px;
`;
const OfferFieldLanguage = ({ getFieldValue }) => {
    const intl = (0, react_intl_1.useIntl)();
    const isBelowXs = (0, react_styled_1.useBreakpoint)((0, styled_breakpoints_1.down)('xs'));
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.List, { name: types_1.EOfferBasicInfoFormField.languages, children: (fields, { add, remove }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [fields.map(({ key, name: listName }) => ((0, jsx_runtime_1.jsxs)("div", { className: "flex-row align-center", children: [(0, jsx_runtime_1.jsx)(LanguageSelectFieldWrapper, { children: (0, jsx_runtime_1.jsx)(LanguageSelectField_1.LanguageSelectField, { name: types_1.EOfferBasicInfoFormField.languageCode, label: intl.formatMessage({
                                    id: 'admin.offer_form.language',
                                }), getFieldValue: getFieldValue, listName: listName, listFieldName: types_1.EOfferBasicInfoFormField.languages, rules: [
                                    {
                                        required: true,
                                        message: intl.formatMessage({ id: 'admin.offer_form.choose_language' }),
                                    },
                                ] }) }), (0, jsx_runtime_1.jsx)(LanguageLevelSelectFieldWrapper, { children: (0, jsx_runtime_1.jsx)(LanguageLevelSelectField_1.LanguageLevelSelectField, { name: types_1.EOfferBasicInfoFormField.languageLevel, label: intl.formatMessage({
                                    id: 'admin.offer_form.language_level',
                                }), listName: listName, rules: [
                                    {
                                        required: true,
                                        message: intl.formatMessage({
                                            id: 'admin.offer_form.choose_language_level',
                                        }),
                                    },
                                ] }) }), !isBelowXs && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(RemoveButton, { onClick: () => remove(listName), size: "middle", type: "default", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "global.remove" }) }) })), isBelowXs && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(icons_1.MinusCircleOutlined, { onClick: () => remove(listName) }) }))] }, key))), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { children: (0, jsx_runtime_1.jsx)(elements_1.Button, { type: "dashed", onClick: () => add(), block: true, icon: (0, jsx_runtime_1.jsx)(icons_1.PlusOutlined, {}), children: (0, jsx_runtime_1.jsx)("span", { className: "m-l-s", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offer_form.add_language" }) }) }) })] })) }));
};
exports.OfferFieldLanguage = OfferFieldLanguage;
